import { render, staticRenderFns } from "./index.vue?vue&type=template&id=200680d4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=200680d4&lang=less&scope=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=200680d4&lang=less&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&id=200680d4&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200680d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200680d4')) {
      api.createRecord('200680d4', component.options)
    } else {
      api.reload('200680d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=200680d4&scoped=true&", function () {
      api.rerender('200680d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deceased/enshrineList/index.vue"
export default component.exports